import  { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Heders from '../components/Headers'
import Banner from '../components/Banner'
import Categorys from '../components/Categorys'
import FeatureProducts from '../components/products/FeatureProducts'
import Products from '../components/products/Products'
import Footer from '../components/Footer'
import { get_products, get_sellers } from '../store/reducers/homeReducer'
import SEO from '../components/SEO'
import BestSellersSection from '../components/best-sellers-section'

const Home = () => {
    const dispatch = useDispatch()
    const {products, latest_product, topRated_product, discount_product } = useSelector(state => state.home)
    useEffect(() => {
        dispatch(get_products())
        dispatch(get_sellers())
    }, [dispatch])
    return (
        <div className='w-full  bg-primaryBackground'>
            <SEO title="" description="A Digital Home for Gul Plaza Businesses" />
            <Heders />
            <Banner />
            <div className='mt-4 bg-card'>
                <Categorys />
            </div>
            <div>
                <BestSellersSection />
            </div>
            <div className='py-[45px]'>
                <FeatureProducts products={products} />
            </div>
            <div className='py-10 md:pb-[30%] sm:pt-0'>
                <div className='w-[85%] flex flex-wrap mx-auto'>
                    <div className="grid w-full grid-cols-3 md-lg:grid-cols-2 md:grid-cols-1 gap-8">
                        <div className='overflow-hidden'>
                            <Products title='New Arrivals' products={latest_product} />
                        </div>
                        <div className='overflow-hidden'>
                            <Products title='Best Sellers' products={topRated_product} />
                        </div>
                        <div className='overflow-hidden'>
                            <Products title='Sale' products={discount_product} />
                        </div>
                    </div>
                </div>
            </div>
            
            <Footer />
        </div>
    )
}

export default Home